import React, { useState, useEffect, useRef } from 'react'
import ProTable from '@ant-design/pro-table'
import { ConfigProvider, Button, Select, Modal, DatePicker, message } from 'antd';
import axios from '../../../utils/AxiosUtil'
import { don_statistic_cols } from '../../../constants/donateConstants';
import locale from 'antd/lib/locale/zh_CN';
import { DownloadOutlined } from '@ant-design/icons';
import { mask, unmask } from '../../../components/reqAndHint';
import date2Str from '../../../utils/date2Str';
import j2eUtil from '../../../utils/j2e';
import { useSelector } from 'react-redux'
const { Option } = Select;
const { RangePicker } = DatePicker;


// 捐款项目统计页面
export default function statistics() {
    const langValue = useSelector(state => state.langList.value)
    let col = [...don_statistic_cols];

    //需要下载的数据
    const [fileData, setFileData] = useState([]);
    //查询的时间范围，用于excel表头
    const [dateRange, setDateRange] = useState([]);
    const [projectOpts, setProjectOpts] = useState([]);
    const [areaOptions, setAreaOptions] = useState([]);

    const handleDownload = () => {
        mask()
        // console.log('fileData:', fileData);
        // console.log('dateRange:', dateRange);
        try {
            //excel
            let excelData = [];
            //表头
            let tblName = ['捐款统计表'];
            if (langValue == 2) {
                excelData.push(['Donation Statistics Table'])
            } else {
                excelData.push(tblName);
            }


            // 表头的日期
            let dateStr
            if (dateRange) {
                let start = date2Str.format(dateRange[0], 'yyyy/MM/dd');
                let end = date2Str.format(dateRange[1], 'yyyy/MM/dd');
                dateStr = [start + '-' + end];
            } else {
                dateStr = [''];
            }
            excelData.push(dateStr);
            // let title1 = ['序号', '地区', '捐款项目', '捐款统计'];
            // excelData.push(title1);
            let title1 = ['序号', '地区', '捐款项目', '笔数', '金额'];
            let title2 = ['Serial number', 'Region', 'Donation items', 'Number of transactions', 'Amount']
            if (langValue == 2) {
                excelData.push(title2);
            } else {
                excelData.push(title1);
            }
            // let title2 = ['', '', '', '笔数', '金额']
            // excelData.push(title2);
            //数据
            fileData.forEach(e => {
                let row = [
                    e['序号'],
                    e['地区'],
                    e['捐款项目'],
                    e['笔数'],
                    e['金额'],
                ];
                excelData.push(row);
            })
            //文件名
            let fileName = (langValue == 2 ? 'Donation project statistics ' : '捐款项目统计 ') + date2Str.format(new Date(), 'yyyy-MM-dd HH：mm：ss') + '.xlsx';
            //表头格式，合并单元格
            // r 是 row ，表示行号，从 0 计起
            // c 是 col ，表示列号，从 0 计起
            // const merge = [
            //     { s: { r: 0, c: 0 }, e: { r: 0, c: 4 } },
            //     { s: { r: 1, c: 0 }, e: { r: 1, c: 4 } },
            //     { s: { r: 2, c: 0 }, e: { r: 3, c: 0 } },
            //     { s: { r: 2, c: 1 }, e: { r: 3, c: 1 } },
            //     { s: { r: 2, c: 2 }, e: { r: 3, c: 2 } },
            //     { s: { r: 2, c: 3 }, e: { r: 2, c: 4 } },
            // ];
            const merge = [
                { s: { r: 0, c: 0 }, e: { r: 0, c: 4 } },
                { s: { r: 1, c: 0 }, e: { r: 1, c: 4 } },
            ];

            j2eUtil.j2e(excelData, fileName, merge);

            unmask();
            message.destroy();
            message.info(langValue == 0 ? <>请在浏览器下方查看文件，并等待下载完成<br />Please view the file below the browser and wait for the download to complete</> : (langValue == 1 ? '请在浏览器下方查看文件，并等待下载完成' : 'Please view the file below the browser and wait for the download to complete'), 10);

        } catch (error) {
            unmask();
            console.log('handleDownload:', error);
            message.error(langValue == 0 ? '下载失败Download failed' : (langValue == 1 ? '下载失败' : 'Download failed'), 2);
        }
    }


    useEffect(() => {
        getProjectOpt();
        getAreaOpt();

        // 在组件卸载时执行
        return () => {
            // console.log('useEffect return');
            setFileData([]);
        };

    }, [])

    // 获取所有项目名,并渲染选择框
    const getProjectOpt = async () => {
        let data = await axios.post('/fund/project/getAll');
        // console.log('getProjectOpt:', data);
        if (data ?.data) {
            // 捐款项目选择框
            let projectArr = []
            data.data.forEach(item => {
                var obj = {
                    ch_pro: item,
                    en_pro: item
                }
                projectArr.push(obj)
            })
            setProjectOpts(projectArr)
        }
    }

    // 获取所有地区，并渲染选择框
    const getAreaOpt = async () => {
        let data = await axios.post('/fund/area/getAll');
        // console.log('getAreaOpt:', data?.data?.data);
        if (data ?.data ?.data) {
            // 地区选择框
            setAreaOptions(data.data.data)
        }
    }

    // 开立日的选择框组件
    col[1].renderFormItem = () => {
        return <RangePicker
            locale={locale}
            format="YYYY-MM-DD"
            placeholder={langValue == 0 ? ['开始日期Start Date', '结束日期End Date'] : (langValue == 1 ? ['开始日期', '结束日期'] : ['Start Date', 'End Date'])}
        />
    };
    col[2].renderFormItem = () => {
        return <Select
            placeholder={langValue == 0 ? '请选择地区(Please select region)：' : (langValue == 1 ? '请选择地区：' : 'Please select region:')}
            style={{ width: 300 }}
            mode="multiple"
            allowClear
            showSearch
        >
            {areaOptions.map((area, i) => {
                return <Option key={area.area} value={area.areaCode + ' ' + area.areaName}>{area.areaCode + ' ' + area.areaName}</Option>
            })}
        </Select>
    };
    col[3].renderFormItem = () => {
        return <Select
            style={{ width: 200 }}
            placeholder={langValue == 0 ? '请选择捐款项目Please select a donation project' : (langValue == 1 ? '请选择捐款项目' : 'Please select a donation project')}
            showSearch
            allowClear
        >
            {projectOpts.map((p, i) => {
                return <Option key={p ?.ch_pro} value={p ?.ch_pro}>{<>{p ?.ch_pro}</>}</Option>
            })}
        </Select>
    };
    const getColumns = (col) => {
        let newCol = [...col];
        newCol.forEach((item, i) => {
            if (i == 3) {
                item.render = (_, item2) => {
                    return <span>{item2['捐款项目']}</span>
                }
            }
            item.title = langValue == 0 ? <>{item.ch_title}<br />{item.en_title}</> : (langValue == 1 ? item.ch_title : item.en_title)
        })
        return newCol
    }

    return (
        <div className='proc-wrapper' id='donation-statis'>
            <ProTable
                // style={{ width: '900px', fontSize: '27px' }}
                sticky
                size="small"
                bordered
                // defaultData={mockData}
                request={async (
                    // 第一个参数 params 查询表单和 params 参数的结合
                    // 第一个参数中一定会有 pageSize 和  current ，这两个参数是 antd 的规范
                    params: {
                        pageSize: number;
                        current: number;
                    },
                    sort,
                    filter,
                ) => {
                    // 这里需要返回一个 Promise,在返回之前你可以进行数据转化
                    // 如果需要转化参数可以在这里进行修改
                    // console.log('pro table params:', params, ' sort:', sort, ' filter:', filter);
                    const coverParams = (params) => {
                        let p = { ...params };
                        // console.log('coverParams:', p);
                        setDateRange(params.开立日);
                        return p;
                    }

                    const data = await axios.post('/fund/donation/projectList', coverParams(params));
                    // console.log('projectList:', data);
                    const { list } = data ?.data;

                    let dataSrc = [...list];

                    setFileData(dataSrc);

                    dataSrc.forEach((d, i) => {
                        d['序号'] = i + 1;
                        d.key = i + 1;
                        d.en_proj = d['捐款项目']
                    });

                    return {
                        data: dataSrc,
                        // success 请返回 true，
                        // 不然 table 会停止解析数据，即使有数据
                        success: true,
                        // 不传会使用 data 的长度，如果是分页一定要传
                        total: dataSrc.length,
                    };
                }}
                columns={getColumns(col)}
                cardBordered
                // toolBarRender={false}
                toolbar={{
                    actions: [
                        <Button className='download-btn' type='primary' icon={<DownloadOutlined />}
                            onClick={handleDownload}
                            disabled={fileData.length == 0}//没有数据时不能下载
                        >{langValue == 0 ? '下载Download' : (langValue == 1 ? '下载' : 'Download')}
                        </Button>
                    ]
                }}
                //工具栏选项
                options={{
                    density: true,
                    fullScreen: true,
                    reload: false,
                    setting: false,
                }}
                editable={{
                    type: 'multiple',
                }}
                columnsState={{
                    persistenceKey: 'pro-table-statistics',
                    persistenceType: 'sessionStorage',
                }}
                rowKey="序号"
                search={{
                    labelWidth: 'auto',
                    span: '5',
                    collapseRender: false,//隐藏收起按钮
                    searchText: langValue == 0 ? '查询Query' : (langValue == 1 ? '查询' : 'Query'),
                    resetText: langValue == 0 ? '重置Reset' : (langValue == 1 ? '重置' : 'Reset'),
                }}
                pagination={{
                    pageSize: 10,
                    pageSizeOptions: [10, 20, 50, 100, 1000],
                    showQuickJumper: true,
                    showSizeChanger: true,
                }}
                dateFormatter="string"
                // headerTitle="捐款项目统计"
                onRequestError={(error) => {
                    error = typeof error == 'object' ? JSON.stringify(error) : error;
                    Modal.error({ title: '表格加载错误' });
                }}
            />
        </div>
    )
}
